import style from "./Funds.module.scss";
import { Button, Input } from "@ui";
import { useEffect, useState } from "react";
import { useAppSelector } from "store/hooks";
import { useUpdateUsersBalanceMutation } from "@RTKQuery/admin/customers/customers";

export function Funds() {
    const { applytTo, selectRows } = useAppSelector(state => state.customersAdminPage)

    const [updateUsersBalance, { isSuccess, isLoading, reset, error }] = useUpdateUsersBalanceMutation();

    const [inputValue, setInputValue] = useState<string>("")

    useEffect(() => {
        let timer: NodeJS.Timeout;

        if (isSuccess) {
            setInputValue("")
            timer = setTimeout(() => {
                reset();
            }, 2500)
        }

        return () => {
            clearTimeout(timer)
        }
    }, [isSuccess])

    return (
        <div className={style.container}>
            <p className="text-center text-[#1B1B1D] text-[16px] font-semibold leading-normal mb-[10px]">Редагування балансу користувачів</p>
            <Input
                value={String(inputValue)}
                onChange={(value) => {
                    setInputValue(value)
                }}
                label="Сума:"
                customStyle={{
                    width: "!w-[300px] !max-w-[300px] !mx-auto !mb-[30px]"
                }}
                error={( inputValue && !/^[-+]?\d*\.?\d+$/.test(inputValue) ) ? "Будь ласка, введіть коректне число." : ""}
            />
            <Button
                tabIndex={-1}
                text={
                    isSuccess
                        ? "Успішно збережено"
                        : "Зберегти"
                }
                color="blue"
                customStyle={{
                    button: "!w-[180px] !h-[38px] ",
                    width: "!mx-auto"
                }}
                disabled={ !inputValue || !/^[-+]?\d*\.?\d+$/.test(inputValue)}
                loading={isLoading}
                errors={[
                    (error && ((extractError) => {
                        return extractError(error)
                    }))
                ]}
                onClick={() => {
                    if (inputValue) {
                        updateUsersBalance({
                            amount: Number(inputValue),
                            user_ids: (applytTo === "selected") ? selectRows : undefined,
                            is_active: (applytTo === "active") ? true : (applytTo === "notActive") ? false : undefined 
                        })
                    }
                }}
                resetStatus={() => {
                    reset();
                }}
            />
        </div>
    )
}